import React from 'react'
import BackToUp from '@uiw/react-back-to-top';
import Ban from '../components/Desktop3/ban/Ban'
import HopCategory from '../components/Desktop5/hop_category/HopCategory';


const Desktop5 = () => {
  return (
    <>
      <Ban/>
      <HopCategory/>
      <div className="container">
        <BackToUp><i class="fa-solid fa-arrow-up"></i></BackToUp>
     </div>
    </>
  )
}

export default Desktop5